import { RadioGroupProps } from '@kizi/shared-components';
import React from 'react';
import { RadioGroup } from './withFormField';
import { FormFieldHOCProps } from '../..';
import { useField, ComponentDescriptor } from '@kizi/comparator-core';

export interface RadioGroupWrapperProps
  extends FormFieldHOCProps,
    RadioGroupProps {
  children?: ComponentDescriptor;
}

export const RadioGroupWrapper: React.FC<RadioGroupWrapperProps> = ({
  containerProps,
  children,
  radios,
  ...restProps
}) => {
  const _field = useField(restProps._fieldName);

  if (!_field) return null;
  return (
    <RadioGroup
      _containerProps={{
        ...containerProps,
      }}
      _labelProps={{ mt: 2 }}
      {...{
        ...restProps,
        radios: radios,
        children,
      }}
      value={_field.value}
    />
  );
};
